import { module } from 'modujs';
import { gsap } from 'gsap';
import { SplitText } from "../libs/gsap/SplitText";

gsap.registerPlugin(SplitText);

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {

		this.isHidden = typeof this.getData('hidden') == "string";

		this.split = new SplitText(this.el, {
			type: 'chars'
		});

		if(this.isHidden) {
			this.hide();
		}
    }

	display(delay = 0) {

		if(this.displayTL != undefined) {
			this.displayTL.kill();
		}
		if(this.hideTL != undefined) {
			this.hideTL.progress(1);
			this.hideTL.kill();
		}

		this.displayTL = gsap.timeline();

		this.displayTL.to(this.split.chars, {
			alpha: 1,
			duration: 0.1,
			delay: delay,
			stagger: {
				amount: 0.2,
				from: "random"
			}
		});
	}

	hide(delay = 0) {
		if(this.hideTL != undefined) {
			this.hideTL.kill();
		}
		if(this.displayTL != undefined) {
			this.displayTL.progress(1);
			this.displayTL.kill();
		}
		
		this.hideTL = gsap.timeline();

		this.hideTL.to(this.split.chars, {
			alpha: 0,
			duration: 0.1,
			delay: delay,
			stagger: {
				amount: 0.2,
				from: "random",
				// repeat: -1
			}
		});
	}

	hover(delay = 0) {
		if(this.hoverTl != undefined) {
			this.hoverTL.kill();
		}
		this.hoverTL = gsap.timeline({repeat: 0});

		this.hoverTL.to(this.split.chars, {
			alpha: 0,
			duration: 0.1,
			delay: delay,
			stagger: {
				amount: 0.08,
				from: "random",
			}
		});
		this.hoverTL.to(this.split.chars, {
			alpha: 1,
			duration: 0.1,
			delay: delay,
			stagger: {
				amount: 0.08,
				from: "random",
			}
		});
	}
}
